import React from "react";
import { Link } from "react-router-dom";

import { H1, H2, ContentHolder } from "commons";

import { routes } from "../helpers/RouteHelpers";

export function Forbidden() {
    return (
        <ContentHolder>
            <H1>Sorry!</H1>
            <H2 secondary textAlign="center">
                <span>You no longer have access to this page. </span>
                <span>Please contact your financial adviser. </span>
                <span>Their contact details can be found </span>
                <Link to={routes.client.contacts()}>here</Link>
            </H2>
        </ContentHolder>
    );
}
